import { TrainerPackageModel } from "@modules/verification/trainer-package/models/TrainerPackageModel";
import { PackageTableRow } from "../PackageTableRow/PackageTableRow";

export function PackageTable({
  packages,
  modal,
}: {
  packages: TrainerPackageModel[];
  modal: any;
}) {
  return (
    <div className="table-responsive shadow-sm border rounded">
      <table className="table table-hover align-middle">
        <thead className="table-light">
          <tr>
            <th>Title</th>
            <th>Category</th>
            <th>Trainer</th>
            <th>Status</th>
            <th>Verified</th>
            <th>Created At</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {packages.map((pkg) => (
            <PackageTableRow key={pkg.id} pkg={pkg} modal={modal} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
